export const endpoints ={
    apiEndpoint: 'ff-master-ff-backend-internal.digital-nonprod.fcalatam.com.br',
    apiProtocol:'HTTPS',
};

// export const endpoints ={
//     apiEndpoint: 'localhost:8080',
// };

/*export const endpoints ={
    apiEndpoint: "http://ec2-54-175-241-24.compute-1.amazonaws.com",
};*/

export const timeoutRequisitionMs = 15000;

export const requestTypes={
    POST: 'POST',
    GET: 'GET',
    PUT: 'PUT',
    DELETE: 'DELETE',
};

export const services={
    auth: '/auth',
    users: '/api/users',
    userProfileDriver: '/api/userProfileDriver',
    tesisGroup: '/api/tesis/group',
    tesisSubgroup: '/api/tesis/subgroup',
    tesisItem: '/api/tesis/item',
    tesisAnomaly: '/api/tesis/anomaly',
    componentGroup: '/api/componentGroups',
    claimed: '/api/claimed',
    anomaly: '/api/anomaly',
    vehicle:'/api/vehicle',
    experience:'/api/experience',
    allExperiences:'/api/allExperiences',
    usedClaimed: '/api/usedClaimed',
};

export const routes = {
    home: "/home",
    login: "/login",
    live: "/live",
    userControl: '/userControl',
    blankPage: "/blankPage",
    users: '/users',
    groups: '/groups',
    newGroup: '/newGroup',
    item: '/item',
    experience: '/experience',
    experiencesHistory: '/experiencesHistory',
};

export const generalConfig = {
    dateFormat: 'DD/MM/YYYY',
    dateFileConcat: 'YYYYMMDDHHmmss',
    timeAlertDefault: 3000,
    intervalDaysDatePicker: 30,
};



// WEBPACK FOOTER //
// ./src/util/config.js